import Vue from 'vue'
import GoogleAuth from 'vue-google-oauth'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(BootstrapVue)

Vue.config.productionTip = false
Vue.use(GoogleAuth, { client_id: '404712600741-jkbjm8a3kn65rto4mhol2m50g4hit0hd.apps.googleusercontent.com' })
Vue.googleAuth().load()

switch (process.env.NODE_ENV) {
  case 'production':
    Vue.prototype.$apiHost = 'api.the-great-shuffle.subversivedata.com'
    Vue.prototype.$apiEndpoint = 'https://api.the-great-shuffle.subversivedata.com'
    break
  default:
    Vue.prototype.$apiHost = 'api-stage.the-great-shuffle.subversivedata.com'
    Vue.prototype.$apiEndpoint = '/api'
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
